/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1800 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Joseph Cheng",
  title: "Hi, I'm Joseph",
  subTitle: emoji(
    "I’m a Software Engineer at Google, with previous experience at Amazon. I graduated with a degree in Computer Science from the University of Waterloo and enjoy building software that solves meaningful problems with real-world impact at global scale."
  ),
  resumeLink:
    "./resume.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/josephchengdev",
  linkedin: "https://www.linkedin.com/in/josephchengdev/",
  gmail: "hello@josephcheng.dev",
  gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University Of Waterloo",
      logo: require("./assets/images/waterloo.png"),
      subHeader: "Bachelor of Computer Science (Honours), Co-operative Program",
      duration: "2018 - 2023",
      descBullets: [
        "Cumulative GPA: 84.00% / Major GPA: 87.53% (Graduated with Distinction)",
        "2019 President’s Scholarship of Distinction",
        "Winter 2019 Math Endowment Fund Computer Science Representative"
      ]
    },
    {
      schoolName: "German Swiss International School",
      logo: require("./assets/images/gsis.png"),
      subHeader: "",
      duration: "Class of 2018",
      descBullets: [
        "2018 - International Baccalaureate Diploma",
        "2016 - International General Certificate of Secondary Education"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Developer",
      company: "Google",
      companylogo: require("./assets/images/google.png"),
      date: "April 2025 – Present",
      desc: "",
      descBullets: [
        "Member of the Gmail Delivery Team which maintains and operates the core email delivery infrastructure of Gmail. The Delivery infrastructure processes billions of messages every day. The mission of the team is to route correctly every message reliably, securely, and efficiently and to make Gmail the best email platform in the world.",
        "Working with C++."
      ]
    },
    {
      role: "Software Engineer",
      company: "Amazon",
      companylogo: require("./assets/images/amazon.jpg"),
      date: "July 2023 - March 2025",
      desc: "",
      descBullets: [
        "Acting as the lead developer for my team in a multi-team initiative with the goal of enabling fulfillment center employees to seamlessly switch between multiple roles resulting in enhanced labor flexibility and driving significant cost savings for Amazon. Also helped to develop the code for rolling out the initiative in Europe.",
        "Updated my team’s critical tier 1 service that vends basic employee information to countless customers to support re-driving employees in bulk leading to rapid recovery in disaster scenarios.",
        "Created a dashboard used at the director level to track critical business metrics and identify focus areas. The dashboard contributed to a decrease in employee safety risks across Amazon fulfillment centers by 5%.",
        "Adapting my team’s product to better suit clients based on interviews we conducted during visits to Amazon fulfillment centers across North America. Led to an improved client experience based on text feedback.",
        "Streamlined my team’s processes in response to team feedback during retrospectives and gave status updates directly to upper management at the end of every sprint during my several month tenure as scrum master. Helped prevent some high severity tickets by developing a system to triage for some auto-escalating low severity tickets.",
        "Worked with Java, Python, SQL, and various AWS Services (EC2, ECS, S3, CloudFormation, DynamoDB, Lambda, and DocumentDB)."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Amazon Web Services (AWS)",
      companylogo: require("./assets/images/aws.jpg"),
      date: "May 2022 - August 2022",
      descBullets: [
        "Created a load balancer log file parser to identify inbound requests using older versions of TLS (1.0/1.1) and extract important header metadata from those requests. Resulted in a system to notify customers using older versions of TLS of the risks it might pose for their applications.",
        "Designed and set up infrastructure to automate and scale the log parser, allowing the parser to run against all API Gateway load balancers across every region simultaneously, thereby greatly improving efficiency.",
        "Created a utility program that queries an internal database to add more useful metadata to the log parser output.",
        "Worked with Python, and various AWS Services (EC2, S3, CloudFormation, Step Functions, Athena, DynamoDB, EventBridge, and Glue)."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Capital One",
      companylogo: require("./assets/images/capitalone.png"),
      date: "January 2022 - April 2022",
      descBullets: [
        "Rebuilt parts of the front end of a client-facing credit card application system using Angular. Implemented the unit tests to go along with it. Resulted in an improved application experience for prospective customers of Capital One.",
        "Helped fix broken internal Angular Components used site wide and updated them to be more inline with an updated website design. Added unit tests to raise code coverage from 70% to 90%.",
        "Worked with Angular, Karma, and Jasmine."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "FundServ",
      companylogo: require("./assets/images/fundserv.jpg"),
      date: "May 2021 – August 2021",
      descBullets: [
        "Updated an existing Excel macro used for payment reconciliation to support a new proprietary file type. Resulted in significant time savings by automating previously manual work.",
        "Worked with a team building a recovery system should hardware fail during data transmission. Responsible for Unit Testing, API design, and Database design. Resulted in halved recovery time in the event of a hardware failure.",
        "Worked with OpenAPI, Spring, JUnit, Java, and Visual Basic."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "FundServ",
      companylogo: require("./assets/images/fundserv.jpg"),
      date: "September 2020 – December 2020",
      descBullets: [
        "Created unit tests and Front-End pages for a transaction system for major financial institutions. Resulted in the ability for clients to monitor transaction flow statistics through Fundserv.",
        "Worked with Angular and Mockito."
      ]
    },
    {
      role: "Full Stack Developer Intern",
      company: "SS&C Technologies",
      companylogo: require("./assets/images/ssnc.png"),
      date: "January 2020 – April 2020",
      descBullets: [
        "Created a catalog website for internal Angular components where each component had a page containing a description, usage examples, and an API reference. Resulted in more efficient development in projects internal components.",
        "Worked on adding client requested functionality to an existing tool that tool in XML files from Jira to produce client facing software release notes. Resulted in turning a several hour manual task into a 10 second job.",
        "Worked with Java, Angular, PostgreSQL, and Swagger."
      ]
    },
    {
      role: "Full Stack Developer Intern",
      company: "SS&C Technologies",
      companylogo: require("./assets/images/ssnc.png"),
      date: "May 2019 – August 2019",
      descBullets: [
        "Within an agile team, developed the several pages for the Front-End of a transaction monitoring website for external clients.",
        "Worked with a team to build an internal knowledge base system to replace an existing legacy solution. Developed Front-End pages, the WYSIWYG editor angular component, APIs, and the design of the Back-End database. Resulted in US$500,000 in savings annually for the company.",
        "Worked with Angular and Swagger."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  // subtitle:
  //   "Want to contact me regarding any interesting opportunities or inquries? Reach out!",
  number: "+1 (647) 904-9544",
  email_address: "hello@josephcheng.dev"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
